export default __webpack_public_path__ + "static/media/151-headphones.d80cccef.png";